import { render, staticRenderFns } from "./JournalReportSettings.vue?vue&type=template&id=f61259be&"
import script from "./JournalReportSettings.vue?vue&type=script&lang=ts&"
export * from "./JournalReportSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports